// ----------------------------------------------------------------------

const ROOTS = {
  APPS: '/apps',
  AUTH: '/auth',
  BILLING: '/billing',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    amplify: {
      signIn: `${ROOTS.AUTH}/amplify/sign-in`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      signUp: `${ROOTS.AUTH}/amplify/sign-up`,
      updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
      resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    },
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
    auth0: {
      signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    },
    supabase: {
      signIn: `${ROOTS.AUTH}/supabase/sign-in`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      signUp: `${ROOTS.AUTH}/supabase/sign-up`,
      updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
      resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    },
  },
  // APPS
  apps : {
    root: ROOTS.APPS,
    storage: `${ROOTS.APPS}/storage`,
    etikettenentfernung: {
      root: `${ROOTS.APPS}/etikettenentfernung`,
      live: `${ROOTS.APPS}/etikettenentfernung/live`,
      list: `${ROOTS.APPS}/etikettenentfernung/list`,
      cleaningImages: `${ROOTS.APPS}/etikettenentfernung/cleaning-images`,
      cleaningImagesView: (id: string) => `${ROOTS.APPS}/etikettenentfernung/cleaning-images/${id}/view`,
    },
    reboPipeline: {
      root: `${ROOTS.APPS}/rebo-pipeline`,
      live: `${ROOTS.APPS}/rebo-pipeline/live`,
      list: `${ROOTS.APPS}/rebo-pipeline/list`,
      view: (id: string) => `${ROOTS.APPS}/rebo-pipeline/${id}/view`,
    },
    webUploads: {
      root: `${ROOTS.APPS}/web-uploads`,
      view: (id: string) => `${ROOTS.APPS}/web-uploads/${id}/view`,
    },
  },
  public: {
    webUploads: {
      root: '/public/web-uploads',
      view: (id: string) => `/public/web-uploads/${id}`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    storage: `${ROOTS.DASHBOARD}/storage`,
    users: `${ROOTS.DASHBOARD}/users`,
    settings: {
      root: `${ROOTS.DASHBOARD}/settings`,
      taraWeights: `${ROOTS.DASHBOARD}/settings/tara-weights`,
    },
    labelEvents: `${ROOTS.DASHBOARD}/events/label`,
    weightEvents: `${ROOTS.DASHBOARD}/events/waage`,
    analytics: {
      root: `${ROOTS.DASHBOARD}/analytics`,
      waage: `${ROOTS.DASHBOARD}/analytics/restmenge`,
      mbg_events: `${ROOTS.DASHBOARD}/analytics/mbg-events`,
    },
    applications: {
      root: `${ROOTS.DASHBOARD}/apps`,
      // segmentAnything: `${ROOTS.DASHBOARD}/models/segments`,
      etikettenentfernung: {
        root: `${ROOTS.DASHBOARD}/apps/etikettenentfernung`,
        list: `${ROOTS.DASHBOARD}/apps/etikettenentfernung/list`,
        live: `${ROOTS.DASHBOARD}/apps/etikettenentfernung/live`,
        view: (id: string) => `${ROOTS.DASHBOARD}/apps/etikettenentfernung/${id}/view`,
      },
      reboPipeline: {
        root: `${ROOTS.DASHBOARD}/apps/rebo-pipeline`,
        list: `${ROOTS.DASHBOARD}/apps/rebo-pipeline/list`,
        live: `${ROOTS.DASHBOARD}/apps/rebo-pipeline/live`,
        view: (id: string) => `${ROOTS.DASHBOARD}/apps/rebo-pipeline/${id}/view`,
      },
      webUploads: {
        root: `${ROOTS.DASHBOARD}/apps/web-uploads`,
        view: (id: string) => `${ROOTS.DASHBOARD}/apps/web-uploads/${id}/view`,
      },
    },
    // Billing
    billing: {
      root: `${ROOTS.BILLING}`,
      consumption: `${ROOTS.BILLING}/consumption`,
      invoices: `${ROOTS.BILLING}/invoices`,
      subscription: `${ROOTS.BILLING}/subscription`,
    },
  },
};
